import { render, staticRenderFns } from "./preLoading.vue?vue&type=template&id=2caa71b6&scoped=true"
import script from "./preLoading.vue?vue&type=script&lang=js"
export * from "./preLoading.vue?vue&type=script&lang=js"
import style0 from "./preLoading.vue?vue&type=style&index=0&id=2caa71b6&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2caa71b6",
  null
  
)

export default component.exports